import { matchPath } from 'react-router-dom';

export function getSuperAgentBreadcrumbTail(pathname: string): string[] {
  if (matchPath({ path: '/agents/:agentId', end: true }, pathname)) {
    return ['Agents', 'Agent details'];
  }
  if (matchPath({ path: '/shops/:shopId', end: true }, pathname)) {
    return ['Shops', 'Shop details'];
  }
  if (matchPath({ path: '/agents/new', end: true }, pathname)) return ['Create agent'];
  if (matchPath({ path: '/dashboard', end: true }, pathname)) return ['Dashboard'];
  if (matchPath({ path: '/agents', end: true }, pathname)) return ['Agents'];
  if (matchPath({ path: '/shops', end: true }, pathname)) return ['Shops'];
  if (matchPath({ path: '/players', end: true }, pathname)) return ['Players'];
  if (matchPath({ path: '/transactions', end: true }, pathname)) return ['Credit transactions'];
  if (matchPath({ path: '/online-transactions', end: true }, pathname)) return ['USD wallet transactions'];
  if (matchPath({ path: '/provider-fees', end: true }, pathname)) return ['Provider fees'];
  if (matchPath({ path: '/popups/send', end: true }, pathname)) return ['Send popup'];
  if (matchPath({ path: '/broadcasts/send', end: true }, pathname)) return ['Send broadcast'];
  if (matchPath({ path: '/payment/return', end: true }, pathname)) return ['Payment'];
  return ['Page'];
}
